module.exports = __webpack_public_path__ + "pbarbalios.jpg?ef3f8785c079ae35dca09ca20615e7bb";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/pbarbalios.jpg
// module id = 702
// module chunks = 0